module.exports = __webpack_public_path__ + "named-aff338c9b58154469eadeae3ca0ea5a4-apple-touch-icon-114x114.png";